<div class="modal-historico">
  <h2 mat-dialog-title>Histórico de Capacidades</h2>
  
  <mat-dialog-content>
    <div *ngIf="historico.length === 0" class="text-center p-3">
      No hay registros de histórico para este polígono.
    </div>
    
    <div *ngIf="historico.length > 0" class="table-container">
      <table mat-table [dataSource]="historico" class="w-100">
        
        <ng-container matColumnDef="FECHA_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let element">{{element.FECHA_EVENTO | date:'dd/MM/yyyy HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="USUARIO_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let element">{{element.USUARIO_EVENTO}}</td>
        </ng-container>

        <ng-container matColumnDef="ACCION">
          <th mat-header-cell *matHeaderCellDef>Acción</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [ngClass]="{'badge-success': element.ACCION === 'INSERT', 'badge-warning': element.ACCION === 'UPDATE', 'badge-danger': element.ACCION === 'DELETE'}">
              {{element.ACCION}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="COD_BODEGA">
          <th mat-header-cell *matHeaderCellDef>Bodega</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.COD_BODEGA_OLD !== element.COD_BODEGA_NEW">
              <small class="cambio-old">{{element.COD_BODEGA_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.COD_BODEGA_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.COD_BODEGA_OLD === element.COD_BODEGA_NEW">{{element.COD_BODEGA_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="CIERRE_AUTOMATICO">
          <th mat-header-cell *matHeaderCellDef>Cierre Auto</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.CIERRE_AUTOMATICO_OLD !== element.CIERRE_AUTOMATICO_NEW">
              <small class="cambio-old">{{element.CIERRE_AUTOMATICO_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.CIERRE_AUTOMATICO_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.CIERRE_AUTOMATICO_OLD === element.CIERRE_AUTOMATICO_NEW">{{element.CIERRE_AUTOMATICO_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="PORCENTAJE_CIERRE">
          <th mat-header-cell *matHeaderCellDef>% Cierre</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.PORCENTAJE_CIERRE_OLD !== element.PORCENTAJE_CIERRE_NEW">
              <small class="cambio-old">{{element.PORCENTAJE_CIERRE_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.PORCENTAJE_CIERRE_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.PORCENTAJE_CIERRE_OLD === element.PORCENTAJE_CIERRE_NEW">{{element.PORCENTAJE_CIERRE_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="CUBICAJE_TOTAL">
          <th mat-header-cell *matHeaderCellDef>Cubicaje</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.CUBICAJE_TOTAL_OLD !== element.CUBICAJE_TOTAL_NEW">
              <small class="cambio-old">{{element.CUBICAJE_TOTAL_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.CUBICAJE_TOTAL_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.CUBICAJE_TOTAL_OLD === element.CUBICAJE_TOTAL_NEW">{{element.CUBICAJE_TOTAL_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="CANTIDAD_ORD_TOTAL">
          <th mat-header-cell *matHeaderCellDef>Cant. Órdenes</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.CANTIDAD_ORD_TOTAL_OLD !== element.CANTIDAD_ORD_TOTAL_NEW">
              <small class="cambio-old">{{element.CANTIDAD_ORD_TOTAL_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.CANTIDAD_ORD_TOTAL_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.CANTIDAD_ORD_TOTAL_OLD === element.CANTIDAD_ORD_TOTAL_NEW">{{element.CANTIDAD_ORD_TOTAL_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cerrar()">Cerrar</button>
  </mat-dialog-actions>
</div>
